<ng-container *ngIf="!!fileType">
	<div
		class="rounded flex items-center justify-center font-bold fileType-{{
			fileType
		}}"
		style="font-size: 14px; line-height: 20px; width: 20px; height: 20px"
		[testHook]="testHooks.FileTypeDiv"
	>
		{{ fileType.substr(0, 1).toUpperCase() }}
	</div>
</ng-container>
